import { Query } from '../../_base/actionBus/Query';
import { ClaimSubject } from '../../models/claims/ClaimSubject';

export class GetClaimSubjects extends Query<ClaimSubject[]> {}
